import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
}

export default function SectionHeader({ icon, title }: SectionHeaderProps) {
  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 1.5,
      }}
    >
      <DSBox sx={{ color: "text.secondary", display: "flex" }}>{icon}</DSBox>
      <DSTypography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: "text.secondary",
          textTransform: "uppercase",
          letterSpacing: 0.5,
          fontSize: 11,
        }}
      >
        {title}
      </DSTypography>
    </DSBox>
  );
}
